<template>
  <div>
    <b-tabs class="mb-1">
      <b-tab :title="$t('cancellation.policies')" active />
      <b-tab :title="$t('cancellation.product_rules')" @click="$router.push('/cancellations/product_rules')" />
      <b-tab :title="$t('cancellation.requests')" @click="$router.push('/cancellations/requests')" />
    </b-tabs>

    <b-button
      v-permission="'cancellation_policies.create'"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      @click="addNew">
      <feather-icon
        icon="PlusIcon"
        class="mr-50"/>
      <span class="align-middle">{{ $t('cancellation.new_policy') }}</span>
    </b-button>

    <Grid
      ref="grid"
      :service="service"
      :hide_actions="true"
      route_name="cancellation_policies"
      order_column="id">
      <template v-slot:gridThead>
        <vs-th key="id" sort-key="id">ID</vs-th>
        <vs-th key="name" sort-key="name">{{ $t('cancellation.policy') }}</vs-th>
        <vs-th key="establishments">{{ $t('cancellation.establishments') }}</vs-th>
        <vs-th key="applies_to" sort-key="applies_to">{{ $t('cancellation.applied_to') }}</vs-th>
        <vs-th key="version">{{ $t('cancellation.version') }}</vs-th>
        <vs-th key="effective">{{ $t('cancellation.effective_since') }}</vs-th>
        <vs-th key="status">{{ $t('cancellation.status') }}</vs-th>
        <vs-th key="actions">Ações</vs-th>
      </template>
      <template v-slot:gridData="props">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in props.data">
          <vs-td width="5%" key="id">
            <div>{{ tr.id }}</div>
          </vs-td>
          <vs-td width="18%" key="name">
            <div>{{ tr.name }}</div>
          </vs-td>
          <vs-td width="16%" key="establishments">
            <div>{{ tr.establishment_names || '—' }}</div>
          </vs-td>
          <vs-td width="22%" key="applies_to">
            <div>{{ tr.applies_to }}</div>
          </vs-td>
          <vs-td width="8%" key="version">
            <span v-if="tr.active_version">v{{ tr.active_version.version }}</span>
            <span v-else-if="tr.draft_version">v{{ tr.draft_version.version }}</span>
            <span v-else>—</span>
          </vs-td>
          <vs-td width="12%" key="effective">
            <span v-if="tr.active_version && tr.active_version.effective_from">
              {{ formatDate(tr.active_version.effective_from) }}
            </span>
            <span v-else>—</span>
          </vs-td>
          <vs-td width="17%" key="status">
            <span class="flex flex-row gap-2">
              <vs-chip v-if="tr.active_version" transparent color="success" class="text-base">
                {{ $t('cancellation.version_status_.AC') }}
              </vs-chip>
              <vs-chip v-if="tr.draft_version" transparent color="warning" class="text-base">
                v{{ tr.draft_version.version }} · {{ $t('cancellation.version_status_.DR') }}
              </vs-chip>
            </span>
          </vs-td>
          <vs-td width="10%" key="actions">
            <div class="flex flex-row gap-2">
              <feather-icon
                v-permission="'cancellation_policies.edit'"
                icon="EditIcon"
                class="h-5 w-5 mb-1 mr-1 stroke-current text-warning cursor-pointer"
                @click="edit(tr.id)"/>
              <feather-icon
                v-permission="'cancellation_policies.delete'"
                icon="Trash2Icon"
                class="h-5 w-5 mb-1 mr-1 stroke-current text-danger cursor-pointer"
                @click="confirmDestroy(tr)"/>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </Grid>
  </div>
</template>

<script>
import { BButton, BTabs, BTab } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import moment from 'moment'

import CancellationPolicyService from '@/services/api/CancellationPolicyService'

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton,
    BTabs,
    BTab
  },
  data: () => ({
    service: null,
    policyToDestroy: null
  }),
  methods: {
    addNew() {
      this.$router.push('/cancellations/policies/create')
    },
    edit(id) {
      this.$router.push(`/cancellations/policies/${id}/edit`)
    },
    confirmDestroy(policy) {
      this.policyToDestroy = policy
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirmação',
        acceptText: 'Sim',
        cancelText: 'Não',
        text: 'Tem certeza que deseja excluir este registro?',
        accept: this.destroy
      })
    },
    destroy() {
      this.$vs.loading()
      this.service.destroy(this.policyToDestroy.id).then(
        () => {
          this.notifySuccess(this.$vs, this.$t('messages.success'))
          this.$refs.grid.fetchGridData(true)
        },
        () => {}
      ).finally(() => { this.$vs.loading.close() })
    },
    formatDate(value) {
      return moment(value).format('DD/MM/YYYY')
    }
  },
  beforeMount() {
    this.service = CancellationPolicyService.build(this.$vs)
  }
}
</script>
